'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermanentIcon = function PermanentIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M-705-794H735v2658H-705z'
            }),
            _react2.default.createElement('rect', {
                x: '.5',
                y: '.5',
                width: '619',
                height: '517',
                rx: '10',
                fill: '#FFF',
                stroke: '#B2B9BF',
                transform: 'translate(-295 -419)'
            }),
            _react2.default.createElement('path', {
                d: 'M30 15c0 8.27-6.73 15-15 15S0 23.271 0 15 6.73 0 15 0s15 6.73 15 15z',
                fill: '#3F5060',
                fillRule: 'nonzero'
            }),
            _react2.default.createElement(
                'g',
                {
                    fill: '#FEFEFE'
                },
                _react2.default.createElement('path', {
                    d: 'M15 6c-3.308 0-6 2.645-6 5.896 0 .768.636 1.392 1.417 1.392.782 0 1.417-.624 1.417-1.392 0-1.715 1.42-3.11 3.166-3.11 1.745 0 3.165 1.395 3.165 3.11 0 1.714-1.42 3.11-3.165 3.11-.782 0-1.417.624-1.417 1.392v2.624c0 .768.635 1.393 1.417 1.393s1.417-.625 1.417-1.393V17.6c2.68-.636 4.583-2.98 4.583-5.736C21 8.63 18.309 6 15 6M15 21.107c-.812 0-1.472.649-1.472 1.447 0 .797.66 1.447 1.472 1.447.812 0 1.473-.65 1.473-1.447 0-.798-.661-1.447-1.473-1.447'
                })
            )
        )
    );
};

PermanentIcon.defaultProps = {
    width: '30',
    height: '30',
    viewBox: '0 0 30 30',
    xmlns: 'http://www.w3.org/2000/svg'
};

var ToolTipPermanent = function (_React$Component) {
    _inherits(ToolTipPermanent, _React$Component);

    function ToolTipPermanent() {
        _classCallCheck(this, ToolTipPermanent);

        return _possibleConstructorReturn(this, (ToolTipPermanent.__proto__ || Object.getPrototypeOf(ToolTipPermanent)).apply(this, arguments));
    }

    _createClass(ToolTipPermanent, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(PermanentIcon, null);
        }
    }]);

    return ToolTipPermanent;
}(_react2.default.Component);

exports.default = ToolTipPermanent;